import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, TextField, Paper, withStyles, Button, FormHelperText, MenuItem } from '@material-ui/core';
import classNames from 'classnames';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
import DropZone from '../../components/DropZone';
import config from '../../config';
import Swal from 'sweetalert2';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage, typeList } from '../../utils/common';

export const dropZoneOption = {
  acceptFile: '.jpg,.png,.jpeg',
  maxSize: 100,
  limitationText: 'สามารถอัพโหลดไฟล์นามสกุล (jpg, png) ครั้งละ 1 ไฟล์และขนาดไม่เกิน 100 MB',
};

class DeviceTypePage extends React.Component {
  dropZoneDeviceType;

  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // i think you are missing this
    // this.initData = this.initData;
    this.state = {
      data: {
        id: '',
        name: '',
        manufacturer: '',
        description: '',
        contactPerson: '',
        address: '',
        tel: '',
        email: '',
        imgUrl: '',
        type: '',
        category: '',
        property: null,
        // type: {
        //   name: '',
        //   category: '',
        //   property: null
        // }
      },
      isUploadingDeviceType: false,
      checked: false,
      errorField: {
        name: false,
        category: false,
        type: false,
        manufacturer: false,
      },
    };
  }

  async componentDidMount() {
    const { offset, limit, search, sort, order } = this.props.deviceType.toJS();
    await this.props.deviceType.getDeviceTypeList(offset, limit, search, sort, order);
    await this.props.deviceType.getCategory();
    this.initData();
  }

  onUploadDeviceType = () => {
    this.setState({ isUploadingDeviceType: true }, () => {
      this.dropZoneDeviceType.upload();
    });
  };

  onUploadDeviceTypeComplete = async (files) => {
    const url = files[0].res.url;
    this.setState({ isUploadingDeviceType: false });
    this.setState((prevState) => {
      prevState.data['imgUrl'] = url;
      return prevState;
    });
    const path = this.props.match.path.replace('/app/devicetype/:id/', '');
    switch (path) {
      case 'edit':
        return await this.updateDeviceType('update');
      default:
        return await this.createDeviceType();
    }
  };

  updateDeviceType = async (task) => {
    const { t } = this.props;
    let { data } = this.state;
    Swal.fire({
      html: `<h4>${t('edit_device_type')}`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: `${t('edit')}`,
      cancelButtonText: `${t('cancel')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.deviceType.updateDeviceType(data, task);
          if (result.statusCode === 200) {
            Swal.fire({ html: `<h4>${t('update_success')}`, type: 'success' }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                this.props.deviceType.setAction('action', true);
                this.props.history.push('../../devicetype');
              } else {
                Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
              }
            });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else if (e.statusCode === 400) {
            const msg = e.error.message || `${t('failed_to_update')}`;
            Swal.fire({ html: `<h4>${msg}`, type: 'error' });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
          }
        }
      }
    });
  };

  createDeviceType = async () => {
    const { t } = this.props;
    let { data } = this.state;
    try {
      const result = await this.props.deviceType.createDeviceType(data);
      if (result.statusCode === 200) {
        Swal.fire({ html: `<h4>${t('create_success')}`, type: 'success' }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            this.props.history.push('../devicetype');
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
          }
        });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else if (e.statusCode === 400) {
        const msg = e.error.message || `${t('failed_to_create')}`;
        Swal.fire({ html: `<h4>${msg}`, type: 'error' });
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
      }
    }
  };

  deleteFileOnClick = async (path) => {
    const { t } = this.props;
    Swal.fire({
      html: `<span class="swal-icon">
              <i
                class="fa fa-trash-o fa-3x fa-border"
                style="border: solid .08em #f27474; border-radius: 1.1em; margin-bottom: 35px; margin-top: 22px;">
              </i>
            </span>
            <br/>
            <h4>${t('delete_photo')}`,
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('delete')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.upload.deleteFile(path);
          if (result.statusCode === 200) {
            this.setState((prevState) => {
              prevState.data['imgUrl'] = null;
              return prevState;
            });
            Swal.fire({ html: `<h4>${t('delete_success')}`, type: 'success' });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        }
      }
      // if (result.value) {
      //   const result = await this.props.upload.deleteFile(path);
      //   if (result) {
      //     this.setState((prevState) => {
      //       prevState.data['imgUrl'] = null
      //       return prevState
      //     })
      //     await this.updateDeviceType('delete');
      //     Swal.fire({html:"<h4>ลบสำเร็จ! <br/>ไฟล์นี้ได้ถูกลบสำเร็จแล้ว", type: "success"});
      //   } else {
      //     Swal.fire({html: "<h4ลบไม่สำเร็จ >br/>ไฟล์นี้ยังไม่ถูกลบ", type: "error"});
      //   }
      // } else if (result.dismiss === Swal.DismissReason.cancel) {
      //   Swal.fire({html: "ยกเลิก <br/>ไฟล์นี้จะยังไม่ถูกลบ :)", type: "error"});
      // }
    });
  };

  goBack() {
    this.props.deviceType.setAction('action', true);
    this.props.history.goBack();
  }

  initData() {
    const { deviceTypes } = this.props.deviceType.toJS();
    const serialPath = this.props.location.pathname.replace('/app/devicetype/', '');
    const id = Number(serialPath.replace('/edit', ''));
    const showDeviceData = deviceTypes.data.find((item) => item.id === id);
    if (showDeviceData) {
      this.setState({
        data: {
          id: showDeviceData.id,
          name: showDeviceData.name,
          manufacturer: showDeviceData.manufacturer,
          description: showDeviceData.description,
          contactPerson: showDeviceData.contactPerson,
          // contractPerson: showDeviceData.contactPerson,
          address: showDeviceData.address,
          tel: showDeviceData.tel,
          email: showDeviceData.email,
          imgUrl: showDeviceData.imgUrl,
          type: showDeviceData.type,
          category: showDeviceData.category,
          property: JSON.parse(showDeviceData.property),
        },
      });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
    if (name === 'category') {
      this.setState((prevState) => {
        prevState.data['type'] = '';
        return prevState;
      });
    }
  };

  // Edit Type
  handleChangeType = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    const type = typeList.find((t) => t.name === value);
    if (type) {
      this.setState((prevState) => {
        prevState.data['type'] = type.name;
        prevState.data['property'] = type.property;
        return prevState;
      });
    }
  };

  validate() {
    const { data } = this.state;
    if (!data.name || !data.category || !data.type || !data.manufacturer) {
      let checkName = !data.name ? true : false;
      let checkCategory = !data.category ? true : false;
      let checkType = !data.type ? true : false;
      let checkManufacturer = !data.manufacturer ? true : false;
      this.setState({
        errorField: {
          name: checkName,
          category: checkCategory,
          type: checkType,
          manufacturer: checkManufacturer,
        },
      });
      return false;
    } else {
      this.setState({
        errorField: {
          name: false,
          category: false,
          type: false,
          manufacturer: false,
        },
      });
    }
    return true;
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: false,
        },
      });
    }
    if (key === 'manufacturer') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          manufacturer: false,
        },
      });
    }
    if (key === 'category') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          category: false,
        },
      });
    }
    if (key === 'type') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          type: false,
        },
      });
    }
  }

  handleCreateDeviceType() {
    if (this.validate()) {
      if (this.dropZoneDeviceType && this.dropZoneDeviceType.state.files.length > 0) {
        if (this.dropZoneDeviceType.state.files[0].size > 1048576) {
          Swal.fire({
            type: 'error',
            text: `ไฟล์ที่อัพโหลดไม่ถูกต้อง รูปต้องมีขนาด ไม่เกิน 1 MB เท่านั้น`,
          });
        } else {
          this.onUploadDeviceType();
        }
      } else {
        this.createDeviceType();
      }
    }
  }

  handleEditDeviceType() {
    if (this.validate()) {
      if (this.dropZoneDeviceType && this.dropZoneDeviceType.state.files.length > 0) {
        if (this.dropZoneDeviceType.state.files[0].size > 1048576) {
          Swal.fire({
            type: 'error',
            text: `ไฟล์ที่อัพโหลดไม่ถูกต้อง รูปต้องมีขนาด ไม่เกิน 1 MB เท่านั้น`,
          });
        } else {
          this.onUploadDeviceType();
        }
      } else {
        this.updateDeviceType('update');
      }
    }
  }

  renderFormCreate() {
    const { classes, t } = this.props;
    const { data } = this.state;
    const { categories } = this.props.deviceType.toJS();
    const type = typeList.filter((t) => t.category === data.category);
    return (
      <React.Fragment>
        <Loader loading={data.isUploadingDeviceType} />
        <Paper className={classes.paper}>
          <PageTitle title={t('create_a_device_type')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name : false}
              />
              <FormHelperText error hidden={!data.reset ? !this.state.errorField.name : true} id='component-error-text'>
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('category')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                select
                id='category'
                name='category'
                fullWidth
                value={data.category}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.category : false}
              >
                {categories.map((c, i) => (
                  <MenuItem value={c.value} key={i}>
                    {c.label}
                  </MenuItem>
                ))}
              </TextField>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.category : true}
                id='component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('type')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                select
                id='type'
                name='type'
                fullWidth
                value={data.type}
                onChange={this.handleChangeType}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.type : false}
              >
                {type.map((value, i) => (
                  <MenuItem value={value.name} key={i}>
                    {value.name}
                  </MenuItem>
                ))}
              </TextField>
              <FormHelperText error hidden={!data.reset ? !this.state.errorField.type : true} id='component-error-text'>
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('manufacturer')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='manufacturer'
                name='manufacturer'
                fullWidth
                value={data.manufacturer}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.manufacturer : true}
                id='component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('contact_person')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='contactPerson'
                name='contactPerson'
                fullWidth
                value={data.contactPerson}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('address')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='address'
                name='address'
                fullWidth
                value={data.address}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tel')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='tel'
                name='tel'
                fullWidth
                value={data.tel}
                onChange={this.handleChange}
                inputProps={{ maxLength: 10 }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('email')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='email'
                name='email'
                fullWidth
                value={data.email}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('image')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              {data.imgUrl ? (
                <div className={classes.imgPreviewContainer}>
                  <div
                    className={classes.imgPreviewDel}
                    onClick={() => {
                      this.deleteFileOnClick(data.imgUrl);
                    }}
                  >
                    <i className='fa fa-times-circle-o' aria-hidden='true' />
                  </div>
                  <div
                    className={classNames(classes.imgPreview, classes.rounded)}
                    style={{
                      background: `url("${data.imgUrl}") center no-repeat`,
                    }}
                  />
                </div>
              ) : (
                <div className={classes.uploadImage}>
                  <DropZone
                    ref={(e) => {
                      this.dropZoneDeviceType = e;
                    }}
                    placeholder={t('click_upload_photo')}
                    url={`${config.api.url}/${config.api.version}/upload`}
                    acceptedFiles={dropZoneOption.acceptFile}
                    maxFileSize={dropZoneOption.maxSize}
                    dirName='device_type'
                    // fileName=""
                    onAllComplete={this.onUploadDeviceTypeComplete}
                    token={localStorage.getItem('id_token') || null}
                  />
                </div>
              )}
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleCreateDeviceType()}
                  className={classes.button}
                >
                  {t('create')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderFormEdit() {
    const { classes, t } = this.props;
    const { data } = this.state;
    const deviceType = this.props.deviceType.toJS();
    const type = typeList.filter((t) => t.category === data.category);

    return (
      <React.Fragment>
        <Loader loading={deviceType.loading || data.isUploadingDeviceType} />
        <Paper className={classes.paper}>
          <PageTitle title={t('edit_a_device_type')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                // value={data.serial}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name : false}
              />
              <FormHelperText error hidden={!data.reset ? !this.state.errorField.name : true} id='component-error-text'>
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('category')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                select
                id='category'
                name='category'
                fullWidth
                value={data.category}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.category : false}
              >
                {deviceType.categories.map((c, i) => (
                  <MenuItem value={c.value} key={i}>
                    {c.label}
                  </MenuItem>
                ))}
              </TextField>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.category : true}
                id='component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('type')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                select
                id='type'
                name='type'
                fullWidth
                value={data.type}
                onChange={this.handleChangeType}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.type : false}
              >
                {type.map((value) => (
                  <MenuItem value={value.name} key={value.name}>
                    {value.name}
                  </MenuItem>
                ))}
              </TextField>
              <FormHelperText error hidden={!data.reset ? !this.state.errorField.type : true} id='component-error-text'>
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('manufacturer')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='manufacturer'
                name='manufacturer'
                fullWidth
                value={data.manufacturer}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.manufacturer : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.manufacturer : true}
                id='component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('contact_person')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='contactPerson'
                name='contactPerson'
                fullWidth
                value={data.contactPerson}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('address')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='address'
                name='address'
                fullWidth
                value={data.address}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tel')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='tel'
                name='tel'
                fullWidth
                value={data.tel}
                onChange={this.handleChange}
                inputProps={{ maxLength: 10 }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                variant='outlined'
                margin='dense'
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('email')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='email'
                name='email'
                fullWidth
                value={data.email}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('image')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              {data.imgUrl ? (
                <div className={classes.imgPreviewContainer}>
                  <div
                    className={classes.imgPreviewDel}
                    onClick={() => {
                      this.deleteFileOnClick(data.imgUrl);
                    }}
                  >
                    <i className='fa fa-times-circle-o' aria-hidden='true' />
                  </div>
                  <div
                    className={classNames(classes.imgPreview, classes.rounded)}
                    style={{
                      background: `url("${data.imgUrl}") center no-repeat`,
                    }}
                  />
                </div>
              ) : (
                <div className={classes.uploadImage}>
                  <DropZone
                    ref={(e) => {
                      this.dropZoneDeviceType = e;
                    }}
                    placeholder={t('click_upload_photo')}
                    url={`${config.api.url}/${config.api.version}/upload`}
                    acceptedFiles={dropZoneOption.acceptFile}
                    maxFileSize={dropZoneOption.maxSize}
                    dirName='device_type'
                    // fileName=""
                    onAllComplete={this.onUploadDeviceTypeComplete}
                    token={localStorage.getItem('id_token') || null}
                  />
                </div>
              )}
            </Grid>
            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleEditDeviceType()}
                  className={classes.button}
                >
                  {t('edit')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderView() {
    const { classes, t } = this.props;
    const { deviceTypes, loading, categories } = this.props.deviceType.toJS();
    const serialPath = this.props.location.pathname.replace('/app/devicetype/', '');
    const id = Number(serialPath.replace('/view', ''));
    const viewDetail = id && (deviceTypes.data || []).find((item) => item.id === id);
    const type = typeList.filter((t) => t.category === (viewDetail && viewDetail.category));
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_a_device_type')} />
          {viewDetail && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('name')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='name'
                  name='name'
                  fullWidth
                  value={viewDetail.name}
                  disabled
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('category')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  select
                  id='category'
                  name='category'
                  fullWidth
                  value={viewDetail.category}
                  variant='outlined'
                  margin='dense'
                  disabled
                >
                  {categories.map((c, i) => (
                    <MenuItem value={c.value} key={i}>
                      {c.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('type')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  select
                  id='type'
                  name='type'
                  fullWidth
                  value={viewDetail.type}
                  variant='outlined'
                  margin='dense'
                  disabled
                >
                  {type.map((value) => (
                    <MenuItem value={value.name} key={value.name}>
                      {value.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('manufacturer')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='manufacturer'
                  name='manufacturer'
                  fullWidth
                  value={viewDetail.manufacturer}
                  disabled
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('description')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='description'
                  name='description'
                  fullWidth
                  value={viewDetail.description}
                  disabled
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('contact_person')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='contactPerson'
                  name='contactPerson'
                  fullWidth
                  value={viewDetail.contactPerson}
                  disabled
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('address')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='address'
                  name='address'
                  fullWidth
                  value={viewDetail.address}
                  disabled
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('tel')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='tel'
                  name='tel'
                  fullWidth
                  value={viewDetail.tel}
                  disabled
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('email')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='email'
                  name='email'
                  fullWidth
                  value={viewDetail.email}
                  disabled
                  variant='outlined'
                  margin='dense'
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('image')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                {viewDetail.imgUrl && (
                  <div className={classes.imgPreviewContainer}>
                    <div
                      className={classNames(classes.imgPreview, classes.rounded)}
                      style={{
                        background: `url("${viewDetail.imgUrl}") center no-repeat`,
                      }}
                    />
                  </div>
                )}
              </Grid>
              <Grid item xs={12}>
                <div className={classes.buttons}>
                  <Button className={classes.button} onClick={this.goBack}>
                    {t('back')}
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
        </Paper>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/devicetype/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormEdit();
        break;
      case 'view':
        result = this.renderView();
        break;
      default:
        result = this.renderFormCreate();
        break;
    }
    return result;
  }
}

const styles = (theme) => ({
  paper: {
    padding: '24px',
    margin: '30px',
    // padding: '50px',
    // marginTop: '-100px'
  },
  wrapContain: {
    padding: 20,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  formControl: {
    width: '100%',
  },
  title: {
    textTransform: 'capitalize',
  },
  imgPreviewContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  imgPreviewDel: {
    color: '#bf1e2e',
    position: 'absolute',
    right: 0,
    fontSize: '1.8rem',
    marginTop: '-21px',
    marginRight: '-11px',
    '&:hover, &:focus': {
      fontSize: '2.2rem',
      cursor: 'pointer',
    },
  },
  imgPreview: {
    backgroundSize: 'contain !important',
    height: '300px',
    border: '1px solid #ced4da',
    borderRadius: '5px',
  },
  imgPreviewDefault: {
    backgroundSize: '100px 100px !important',
    height: '300px',
    border: '1px solid #ced4da',
    borderRadius: '5px',
  },
  uploadImage: {
    marginTop: '10px',
  },
});
export const page = inject('deviceType', 'upload')(observer(DeviceTypePage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
